module.exports = __webpack_public_path__ + "static/media/bfile-user.7d73cf28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-user.svg
// module id = 3106
// module chunks = 0